// extracted by mini-css-extract-plugin
module.exports = {"policy":"CancellationPolicyAck_policy__J1ZCY","text":"CancellationPolicyAck_text__ocBp7","textButton":"CancellationPolicyAck_textButton__Krw9o"};